import React, { Component, Fragment } from "react";
import Button from "../../../components/Button2";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";

class SuccessfulPurchase extends Component {
    renderNonTrialSuccessMessage() {
        const { message, productDisplayName } = this.props;
        if (message) {
            return message;
        }
        return (<Fragment>You have successfully upgraded to <span>{productDisplayName}</span>.</Fragment>);
    }

    render() {
        const { productDisplayName, showTrial, trialExpirationDate, callToActionText, additionalMessage } = this.props;

        if (showTrial) {
            return (
                <BeautifulDialog preventClose={true}>
                    <DialogContent>
                        <div id="successful_purchase">
                            <div id="big_icon">
                                <i className="micon">check</i>
                            </div>
                            <div id="message">Great! You've just started your 14-day free trial for Beautiful.ai {productDisplayName}.</div>
                            <div className="receipt">
                                Cancel anytime before {trialExpirationDate} and you will not be charged.
                            </div>
                            {additionalMessage && <div className="receipt">{additionalMessage}</div>}
                            <Button onClick={this.props.onCallToActionClick} label={callToActionText} />
                        </div>
                    </DialogContent>
                </BeautifulDialog>
            );
        } else {
            return (
                <BeautifulDialog preventClose={true}>
                    <DialogContent>
                        <div id="successful_purchase">
                            <div id="big_icon">
                                <i className="micon">check</i>
                            </div>
                            <div id="message">
                                {this.renderNonTrialSuccessMessage()}
                            </div>
                            <div className="receipt">A receipt will be sent to your email shortly</div>
                            {additionalMessage && <div className="receipt">{additionalMessage}</div>}
                            <Button onClick={this.props.onCallToActionClick} label={callToActionText} />
                        </div>
                    </DialogContent>
                </BeautifulDialog>
            );
        }
    }
}

export default SuccessfulPurchase;
